import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircle} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import {DateTime} from "luxon";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import {ModelResult} from "../modelResultsSlice";

type ForwardDispersionLegendProps = {
    modelResult: ModelResult
}

const ForwardDispersionLegend: React.FC<ForwardDispersionLegendProps> = ({modelResult}: ForwardDispersionLegendProps)  => {
    return (
        <div>
            <ul className="list-inline" style={{marginBottom: 0}}>
                <li className="list-inline-item d-none d-sm-inline">
                    <b>Result</b>
                </li>
                <li className="list-inline-item" style={{color: 'white', fontSize: 'smaller'}}>
                    {DateTime.fromISO(modelResult.request_json.detection_datetime)
                        .toLocal().toLocaleString(DateTime.DATETIME_SHORT)}
                </li>
                <li className="list-inline-item d-none d-sm-inline">
                    <b>Confidence:</b>
                </li>
                <li className="list-inline-item" style={{color: 'white', fontSize: 'smaller'}}>
                    {modelResult.confidence}
                </li>

                <li className="confidence-tooltip">
                    <FontAwesomeIcon icon={faInfoCircle} />
                    <span className="confidence-tooltiptext">Choosing a more representative met station is more important than obtaining a better Confidence result. Use the most representative (usually the closest) met station regardless of Confidence result.</span>
                </li>
            </ul>

            <ul className="list-inline" style={{marginBottom: 0}}>
                <li className="list-inline-item d-none d-sm-inline">
                    <b>Impact Probability</b>
                </li>
                <li className="list-inline-item" style={{color: 'white', fontSize: 'smaller'}}>
                    <FontAwesomeIcon icon={faCircle} style={{color: 'rgba(0,0,255)'}}/>
                    Most likely
                </li>
                <li className="list-inline-item" style={{color: 'white', fontSize: 'smaller'}}>
                    <FontAwesomeIcon icon={faCircle} style={{color: 'rgba(0,165,255)'}}/>
                    Moderately likely
                </li>
                <li className="list-inline-item" style={{color: 'white', fontSize: 'smaller'}}>
                    <FontAwesomeIcon icon={faCircle} style={{color: 'rgba(0,255,0)'}}/>
                    Less likely
                </li>
                <li className="list-inline-item">
                    <small>
                        Area outside shaded region is least likely impact
                    </small>
                </li>
            </ul>
        </div>

    )
}

export default ForwardDispersionLegend